module.exports = __webpack_public_path__ + "static/media/ic-edit.3ec5e45f.svg";